export const COLORS = {
  white: '#ffffff',
  black: '#2B2B2B',
  primary: '#bbb2e9',
  secondary: '#808080',
  Morskoi: '#04758E'
};
